module.exports = __webpack_public_path__ + "static/media/staff coordinator.08ca184c.svg";